import { RECEIVE_INITIAL_STATE } from "@/components/access/ducks/Actions"
import {
  RECEIVE_CREATE_CUSTOMER_SUCCESS,
  RECEIVE_TICKET,
  SET_CUSTOMER,
} from "@/components/customer/ducks/Actions"

const defaultState = {
  customer: null,
  activeTicket: {},
}

const userCustomerReducer = (oldState = defaultState, action) => {
  Object.freeze(oldState)
  switch (action.type) {
    case RECEIVE_INITIAL_STATE: {
      return {
        ...oldState,
        customer: action.response.customer,
      }
    }

    case SET_CUSTOMER:
      return {
        ...oldState,
        customer: action.customer,
      }

    case RECEIVE_TICKET:
      return {
        ...oldState,
        activeTicket: action.ticket,
      }
    case RECEIVE_CREATE_CUSTOMER_SUCCESS:
      return {
        ...oldState,
        activeTicket: {},
      }

    default:
      return oldState
  }
}

export default userCustomerReducer
